import React, { useState, useEffect } from "react";
import {
  Button,
  Container,
  Row,
  Col,
  FormGroup,
  Label,
  Alert
} from "reactstrap";
import { LandingPageHeader, DemoFooter, Info } from "./../../../components/molecules/";
import NavbarMenu from "../../../components/molecules/Navbar/Navbar";
import Hero from "../../../components/molecules/Hero/Hero";
import Benefit from "../../../components/molecules/Benefit/Benefit";
import Term from "../../../components/molecules/Term/Term";
import Form from "../../../components/molecules/Form/Form";

function LandingPage() {

  return (
    <>      
      <NavbarMenu />
      <Hero />
      <Benefit />
      <Term />
      <Form />
      <DemoFooter />
    </>
  );
}

export default LandingPage;
